import {spotheroGet} from 'api';
import {MonthlyRate, MonthlyRateResponse} from 'api/rates/rates.types';
import {AxiosRequestConfig} from 'axios';
import {stripHtml} from 'string-strip-html';
import {camelizeKeys} from 'utils/format-strings';

/**
 * Format the monthly rates response
 */
const formatMonthlyRatesResponse = (
    response: MonthlyRateResponse[]
): MonthlyRate[] => {
    const camelizedResponse: MonthlyRate[] = camelizeKeys(response);

    const formattedResponse = camelizedResponse.map((rate) => {
        return {
            ...rate,
            description: stripHtml(rate.newDescription).result,
            isParkChirpRate: Boolean(rate?.externalVendors?.parkchirpRateId),
        };
    });

    return formattedResponse;
};

/**
 * Get monthly rates for a facility
 * @see https://spothero.com/api/v1/docs/endpoints/?new-docs=true#!/Facilities/get_facilities_facility_id_monthly_rental_rules
 */
export const getMonthlyRates = async (
    facilityId: number,
    config: AxiosRequestConfig
) => {
    const response = await spotheroGet<MonthlyRateResponse[]>(
        `facilities/${facilityId}/monthly-rental-rules/?include=external_vendors`,
        {},
        config
    );

    const formatttedResponse = formatMonthlyRatesResponse(
        response.data.data.results
    );

    return formatttedResponse;
};
